import Icon from '../components/Icon.vue'

Icon.register({
  industry: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M475.1 163.8c16-10.2 36.9 1.3 36.9 20.2v272c0 13.3-10.7 24-24 24h-464c-13.3 0-24-10.7-24-24v-400c0-13.3 10.7-24 24-24h112c13.3 0 24 10.7 24 24v196.3l139.1-88.5c16-10.2 36.9 1.3 36.9 20.2v68.3z'
      }
    ]
  }
})
